/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Condition types for achievement evaluation.
 * Most types count HubPointTransaction records by source.
 * POINTS_EARNED checks HubMemberPoints.totalEarned.
 * MEMBER_DAYS computes days since HubFollow.followedAt.
 * LEADERBOARD_FINISHES counts times a user placed in any leaderboard period.
 * 
 * @export
 */
export const AchievementConditionType = {
    POINTS_EARNED: 'POINTS_EARNED',
    CHALLENGE_WINS: 'CHALLENGE_WINS',
    CHALLENGE_PARTICIPATIONS: 'CHALLENGE_PARTICIPATIONS',
    LEADERBOARD_FINISHES: 'LEADERBOARD_FINISHES',
    REFERRAL_COUNT: 'REFERRAL_COUNT',
    STREAK_DAYS: 'STREAK_DAYS',
    MEMBER_DAYS: 'MEMBER_DAYS',
    SPONSOR_ENGAGEMENTS: 'SPONSOR_ENGAGEMENTS'
} as const;
export type AchievementConditionType = typeof AchievementConditionType[keyof typeof AchievementConditionType];


export function instanceOfAchievementConditionType(value: any): boolean {
    for (const key in AchievementConditionType) {
        if (Object.prototype.hasOwnProperty.call(AchievementConditionType, key)) {
            if (AchievementConditionType[key as keyof typeof AchievementConditionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AchievementConditionTypeFromJSON(json: any): AchievementConditionType {
    return AchievementConditionTypeFromJSONTyped(json, false);
}

export function AchievementConditionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AchievementConditionType {
    return json as AchievementConditionType;
}

export function AchievementConditionTypeToJSON(value?: AchievementConditionType | null): any {
    return value as any;
}

export function AchievementConditionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AchievementConditionType {
    return value as AchievementConditionType;
}

